module.exports = "/images/extra-luggage.svg?dca008bfc3225b021e07e0f65100493f";